import { useCallback } from "react";

import { useAppDispatch, useAppStore } from "app/redux-store-interactions";
import { capturePropertyFilter, propertiesActions } from "features/properties/slice";
import { undoRedoActions } from "features/undoRedo";
import { captureVisibilitySnapshot, restoreVisibility } from "utils/objectActions";

import { consumeMobileMenuDismissed } from "../mobileMenuDismissalFlag";
import { renderActions, selectIsXRayActive } from "../renderSlice";

/**
 * Toggle X-ray from the toolbar or keyboard shortcut.
 *
 * Entering dismisses the context menu. While X-ray is on, the current
 * selection IDs stay frozen (see HighlightedProvider and setMainObject)
 * until X-ray is turned off.
 */
export function useToggleXRayMode() {
    const dispatch = useAppDispatch();
    const store = useAppStore();

    return useCallback(() => {
        consumeMobileMenuDismissed();

        const state = store.getState();
        const visibilityBefore = captureVisibilitySnapshot(state);
        const propertyFilter = capturePropertyFilter(state);
        const leavingXRay = selectIsXRayActive(state);

        const execute = () => {
            dispatch(renderActions.toggleXRayMode());
            // Leaving ends the "similar objects" filter the Properties checkboxes describe.
            if (leavingXRay) {
                dispatch(propertiesActions.clearPropertySelection());
            }
        };
        execute();

        dispatch(
            undoRedoActions.push({
                description: "Toggle X-Ray mode",
                undoCallback: () => {
                    restoreVisibility({ dispatch, snapshot: visibilityBefore });
                    // After the visibility, which clears the checkboxes on its way through.
                    dispatch(propertiesActions.setPropertyFilter(propertyFilter));
                },
                redoCallback: execute,
            }),
        );
    }, [dispatch, store]);
}
